import React from 'react'
import {Box, HStack, Link, StyleProps, useMultiStyleConfig} from '@chakra-ui/react'
import {CrossNavigationCategory} from '_types'
import {useAnalytics} from '_customHooks'

interface CrossCategoryNavigationProps {
    categories: Array<CrossNavigationCategory>
    variant: 'top' | 'bottom'
}

const CrossCategoryNavigation: React.FC<CrossCategoryNavigationProps> = ({categories, variant}) => {
    const styles = useMultiStyleConfig('CrossCategoryNavigation', {variant}) as Record<string, StyleProps>
    const {analyticsEventCrossCategoryNavigationClick} = useAnalytics()

    const handleClick = (category: CrossNavigationCategory) => {
        analyticsEventCrossCategoryNavigationClick({
            eventAction: variant === 'top' ? 'header' : 'footer',
            eventLabel: category?.id,
            menuHierarchy: categories.indexOf(category) + 1,
        })
    }

    return (
        <Box {...styles.wrapper} data-testid="cross-category-navigation">
            <HStack {...styles.container} data-testid={`cross-category-navigation-${variant}`}>
                {categories.map((category) => (
                    <Link
                        variant="hoverUnderline"
                        {...styles.link}
                        key={category?.id}
                        href={category?.url}
                        onClick={() => handleClick(category)}
                        aria-label={category?.name}
                    >
                        {category?.name}
                    </Link>
                ))}
            </HStack>
        </Box>
    )
}

export {CrossCategoryNavigation}
